import React from 'react';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CustomCard from '../../../components/CustomCard';
import { useGlobalConfig } from '../../../components/globalConfig/GlobalConfigContext';

const ConsentSection = ({
                          isAdminReservation = true,
                          accepted,
                          changeAccepted,
                        }) => {
  const { consentTextAdmin, consentTextClient, rodoText } = useGlobalConfig();

  const label = (
    <>
      {isAdminReservation ? consentTextAdmin : consentTextClient}{' '}
      <Link
        to="/legal-document/actual/regulamin"
        target="_blank"
        rel="noopener noreferrer"
      >
        regulamin
      </Link>
      ,{' '}
      <Link
        to="/legal-document/actual/polityka-prywatnosci"
        target="_blank"
        rel="noopener noreferrer"
      >
        politykę prywatności
      </Link>{' '}
      oraz{' '}
      <Link
        to="/legal-document/actual/zasady-anulowania-rezerwacji"
        target="_blank"
        rel="noopener noreferrer"
      >
        zasady anulowania rezerwacji
      </Link>
      .
      <span className="text-danger"> *</span>
    </>
  );

  return (
    <CustomCard title="Zgody i obowiązki informacyjne" shadow={false}>
      <p className="form-text text-muted mb-2">
        <span className="text-danger">*</span> Pola oznaczone gwiazdką są obowiązkowe.
      </p>

      <Form.Check
        type="checkbox"
        id="termsConsent"
        checked={accepted}
        onChange={() => changeAccepted(!accepted)}
        label={label}
        required
        className="mb-3"
      />

      <div className="alert alert-secondary small" role="alert">
        <strong>Administrator danych:</strong> {rodoText}{' '}
        <Link
          to="/legal-document/actual/polityka-prywatnosci"
          target="_blank"
          rel="noopener noreferrer"
        >
          polityce prywatności
        </Link>
        .
      </div>
    </CustomCard>
  );
};

export default ConsentSection;
